// Trail segment length is stored in feet.
// Format a feet value for display as whole feet with thousands separators, e.g. "1,056 ft".
// Returns null for missing / non-positive values so callers can conditionally render.
export function formatFeet(value) {
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0) return null;
  return `${Math.round(n).toLocaleString()} ft`;
}
